<template>
  <div class="rtl pa-4" style="max-width: 1200px; margin: auto;">
    <v-row>
      <v-col cols="12" md="6">
        <v-card elevation="2" class="rounded-lg">
          <v-card-title class="headline blue-grey--text text--darken-4">
            پکیج‌ها
          </v-card-title>
          <v-divider></v-divider>
          <v-expansion-panels accordion flat>
            <v-expansion-panel v-for="pkg in packages" :key="pkg.codename">
              <v-expansion-panel-header class="font-weight-bold">
                {{ pkg.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <package-form
                  :item="pkg"
                  :isPackage="true"
                  @save="savePackage"
                  @recalculate="recalculate"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card elevation="2" class="rounded-lg">
          <v-card-title class="headline blue-grey--text text--darken-4">
            افزونه‌ها
          </v-card-title>
          <v-divider></v-divider>
          <v-expansion-panels accordion flat>
            <v-expansion-panel v-for="ext in extensions" :key="ext.codename">
              <v-expansion-panel-header class="font-weight-bold">
                {{ ext.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <package-form
                  :item="ext"
                  @save="savePackage"
                  @recalculate="recalculate"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PackageForm from "@/views/panel/PackageForm.vue";
export default {
  components: {
    PackageForm,
  },
  data() {
    return {
      packages: [],
      extensions: [],
    };
  },
  created() {
    this.getPackages();
    this.getExtensions();
  },
  methods: {
    getPackages() {
      this.request({
        url: this.endpoint("subscriptions/packages/"),
        method: "get",
        success: (data) => {
          this.packages = data;
        },
      });
    },
    getExtensions() {
      this.request({
        url: this.endpoint("subscriptions/extensions"),
        method: "get",
        success: (data) => {
          this.extensions = data;
        },
      });
    },
    savePackage(itemToSave) {
      const url = this.endpoint(`/sobhanAdmin/package/${itemToSave.codename}/`);
      this.request({
        url,
        method: "put",
        data: itemToSave,
        success: () => {
          this.getPackages();
          this.getExtensions();
          this.successNotify();
        },
      });
    },
    recalculate(item, period) {
      const p = item.prices[period];
      const discount = p.discount_percentage || 0;
      const base = p.original_price || 0;
      this.$nextTick(() => {
        p.final_price = base - Math.floor((base * discount) / 100);
      });
    },
  },
};
</script>

<style scoped>
.rtl {
  direction: rtl;
  font-family: Vazir, "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.v-expansion-panel-header {
  font-size: 1.1rem;
}

.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 24px 16px;
}

.subtitle-1 {
    font-weight: 600;
    color: #455A64;
}
</style>